import { FC } from 'react';
import { useSelector, useDispatch } from '@cbridge-utils/react-redux';
import { FilterBlockItemBase, IFilterItemRendererProps } from '@cbridge-tools/filters-panel';
import { streamPropsSelector } from './Stream.selector';
import { StreamsFilterAction } from '../../../streamsFilter.action';

export const Stream: FC<IFilterItemRendererProps> = (props) => {
  const { item, depth } = props;
  const { value } = item;

  const { isSelected } = useSelector(streamPropsSelector, { streamId: Number(value) });
  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch(StreamsFilterAction.toggleSelect({ streamId: Number(value) }));
  };

  return (
    <FilterBlockItemBase
      item={item}
      depth={depth}
      isSelected={isSelected}
      onClick={handleClick}
    />
  );
};
